export default __webpack_public_path__ + "static/media/qb_mod_icon.d1cf9217.svg";